import { useMemo, useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GetGroupsListRequest, GetGroupsListResponse } from 'Services/Api/Groups/Types';
import { DEFAULT_TABLE_REQUEST_VALUES } from 'Pages/Groups/Group/Group';
import { GET_GROUPS_LIST } from 'Services/Api/Groups/Queries';

export const useTenants = () => {
    const [getGroup, { data, loading, refetch, error }] = useLazyQuery<
        GetGroupsListResponse,
        GetGroupsListRequest
    >(GET_GROUPS_LIST, {
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true
    });

    // Transform raw data into Select-friendly labels/values
    const tenants = useMemo(() => {
        return (
            data?.listGroups?.map((el) => ({
                label: el.name,
                value: el.id
            })) ?? []
        );
    }, [data?.listGroups]);

    // Reusable fetch function
    const fetchTenants = useCallback((
        values: GetGroupsListRequest = DEFAULT_TABLE_REQUEST_VALUES
    ) => {
        const variables: GetGroupsListRequest = {
            sort: values.sort,
            filters: {
                ...values.filters,
                depth: 1,
                parentId: null
            }
        };

        // Use refetch if already called once, otherwise use the trigger function
        if (refetch)  return refetch(variables);
        else return getGroup({ variables });
    }, [getGroup, refetch]);

    return {
        tenants,
        fetchTenants,
        loading,
        error
    };
};